import { Rule } from "antd/es/form"

export const urlValidator = (message = "Please enter a valid URL"): Rule => ({
  validator: (_, value) => !value || /^https?:\/\/.+/i.test(value)
    ? Promise.resolve()
    : Promise.reject(new Error(message)),
})
